import * as Sentry from "@sentry/react"
import { browserTracingIntegration } from "@sentry/react"

export function initSentry() {
  if (!import.meta.env.PROD) return

  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn) return

  Sentry.init({
    dsn,
    integrations: [browserTracingIntegration()],
    tracesSampleRate: 0.5,
    release: APP_RELEASE,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "production",
    ignoreErrors: [
      "ResizeObserver loop",
      "Network request failed",
      "Load failed",
      "ChunkLoadError",
    ],
    beforeSend(event, hint) {
      const msg = (hint.originalException as Error)?.message
      if (msg?.includes("window.webkit.messageHandlers")) {
        return null
      }
      return event
    },
  })
}
